import styled, {css} from "styled-components";

export interface ITooltipContainerBoxStylingProps {
  backgroundColor?: string;
  textColor?: string;
  borderColor?: string;
  hasGlow?: boolean;
}

interface ITooltipContainerBoxProps extends ITooltipContainerBoxStylingProps {
  active: boolean;
  zIndex: number;
  animated: boolean;
}

function activate(isActive: boolean, isAnimated: boolean) {
  if(!isActive) {
    return css`display: none;`
  }

  if(isAnimated) {
    return css`animation: TooltipAppearAnimation 1s ease-in;`
  }

  return css`display: flex;`
}

export const TooltipContainerDefaultBox = styled.div<ITooltipContainerBoxProps>`
  @keyframes TooltipAppearAnimation {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  
  display: flex;
  ${props => activate(props.active, props.animated)}
        
  min-width: 330px;
  min-height: 80px;
  
  align-items: center;

  z-index: ${props =>props.zIndex};
  
  background: ${({backgroundColor, theme}) => backgroundColor ? backgroundColor : theme.colors.background};
  color: ${({textColor, theme}) => textColor ? textColor : theme.colors.textLight};
  
  border-color: ${({borderColor, theme}) => borderColor ? borderColor : theme.colors.boxBorderContrast};
  border-width: 1px;
  border-style: solid;
  border-radius: 15px;

  ${({hasGlow}) => hasGlow ? css`box-shadow: 0 0 12px 1px ${props => props.theme.colors.brandPrimary};` : null}
  
  padding: 5px;
  
  //Arrow spacing configuration
  &[data-popper-placement^='top'] > #tool-tip-container-arrow {
    bottom: -7px;
    &:before { transform: rotate(-45deg) };
  }
  
  &[data-popper-placement^='bottom'] > #tool-tip-container-arrow {
    top: -7px;
    &:before { transform: rotate(45deg) };
  }
  
  &[data-popper-placement^='left'] > #tool-tip-container-arrow {
    right: -7px;         
    &:before { transform: rotate(135deg) }; //180 - 45
  }
  
  &[data-popper-placement^='right'] > #tool-tip-container-arrow {
    left: -7px;         
    &:before { transform: rotate(315deg) }; //360 - 45
  }
`;